import TeamPitcherModel from '../models/TeamPitcherModel';
import { stitchDefaults } from './defaults';

export default {
    ...stitchDefaults,
    model: TeamPitcherModel,
    pathTemplate: `bdfed/matchup/{gamePk}?statList={statList}`
};